module.exports = __webpack_public_path__ + "static/media/dj.db0ee938.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/front/css/dj.jpg
// module id = 23
// module chunks = 0